import React, { Component, Fragment } from 'react'
import { Redirect } from 'react-router'
import PropTypes from 'prop-types'
import { Header, Heading, Paragraph, Button, Logo } from '@scentregroup/ui'

import withProduct from '../../../containers/with-product'
import Spinner from '../../../components/spinner'

const productTimeout = 1000

class Buy extends Component {
  componentDidMount() {
    setTimeout(this.goToProduct, 100)
  }

  collectUtmData = callback => {
    const consumerIdLength = 35
    const chars =
      '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
    const charsLength = chars.length
    const pipe = '%7C' // pipe
    const product = this.props.product

    if (!product) {
      return setTimeout(this.goToProduct, productTimeout)
    }

    let customerId = ''
    while (customerId.length < consumerIdLength) {
      customerId += chars.charAt(Math.floor(Math.random() * charsLength))
    }

    let ptu = product.retailerProductUrl

    function getParameterByName(name) {
      const escapedName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
      const regex = new RegExp(`[\\?&]${escapedName}=([^&#]*)`)
      const results = regex.exec(window.location.search)
      if (results == null) {
        return ''
      } else {
        return decodeURIComponent(results[1].replace(/\+/g, ' '))
      }
    }

    function addClientId(p, clientId) {
      return p.replace(
        `${pipe}${pipe}${pipe}/adref:`,
        `${clientId}${pipe}${pipe}${pipe}/adref:`
      )
    }

    function addUtmData(p) {
      const queryString = window.location.search

      const utmSource = queryString.match(/utm_source=([^&]*)/)
      const utmMedium = queryString.match(/utm_medium=([^&]*)/)
      const utmKeyword = queryString.match(/utm_keyword=([^&]*)/)

      let utmData = utmSource ? utmSource[1] : ''
      utmData += pipe
      utmData += utmMedium ? utmMedium[1] : ''
      utmData += pipe
      utmData += utmKeyword ? utmKeyword[1] : ''

      return p.replace(`${pipe}${pipe}/adref:`, `${utmData}/adref:`)
    }

    // ga takes too long to load, we need the clientId already in the query string
    const clientId = getParameterByName('gaClientId')
    if (clientId) {
      ptu = addClientId(ptu, clientId)
    }

    ptu = addUtmData(ptu)

    return callback(ptu)
  }

  goToProduct = () => {
    this.collectUtmData(url => window.location.replace(url))
  }

  render() {
    const { product, redirect } = this.props
    if (redirect) {
      return <Redirect to={redirect} />
    }

    return (
      <Header>
        <Logo />
        <Spinner className="brand" />
        {product && (
          <Fragment>
            <Heading>{`We're connecting you to the ${product.retailer.name} website.`}</Heading>
            <Paragraph>
              You are now leaving the Westfield website. <br />
              Our Terms and Conditions and Privacy Policy no longer apply.
            </Paragraph>
            <Paragraph>
              <Button type="tertiary">Click here</Button> to visit the
              retailer&apos;s site directly.
            </Paragraph>
          </Fragment>
        )}
      </Header>
    )
  }
}

Buy.propTypes = {
  product: PropTypes.object,
  redirect: PropTypes.string,
}

export default withProduct(Buy)
